export type HelpModeId = "rescue" | "implement" | "optimize" | "operate";

export type HelpMode = {
  id: HelpModeId;
  number: string;
  verb: string;
  situation: string;
  line: string;
  examples: string[];
};

export const helpModes: HelpMode[] = [
  {
    id: "rescue",
    number: "01",
    verb: "Rescue",
    situation: "Something is broken or at risk.",
    line: "We step in fast, get the next payroll out correctly, and stop the damage — then find out why it happened.",
    examples: ["Payroll is due and no one can run it", "An implementation is going sideways", "Tax filings have gone wrong"],
  },
  {
    id: "implement",
    number: "02",
    verb: "Implement",
    situation: "You’re building or changing a system.",
    line: "We implement HRIS and payroll systems correctly the first time — or take over one that isn’t going well.",
    examples: ["New HRIS or payroll platform", "Switching vendors", "Integrations and parallel testing"],
  },
  {
    id: "optimize",
    number: "03",
    verb: "Optimize",
    situation: "It works — but not well enough.",
    line: "We find what’s set up wrong, done by hand, or never written down — and we fix it.",
    examples: ["Configuration review and correction", "Too much manual work", "Systems your team avoids"],
  },
  {
    id: "operate",
    number: "04",
    verb: "Operate",
    situation: "You need experienced people to keep it running.",
    line: "We run payroll, support your systems, and cover the gaps — every cycle.",
    examples: ["Ongoing payroll processing", "System administration", "Backup and fractional leadership"],
  },
];
